import { AccountListDTO } from '../account/account-list.dto';
import { PricelistItemListDTO } from '../pricelist-item/pricelist-item-list.dto';
import { TeamAccessDTO } from '../team/team-access.dto';

export class PricelistDTO extends TeamAccessDTO {

    id: string;

    name: string;

    description: string;

    currency: string;

    accounts: Array<AccountListDTO>;

    items: Array<PricelistItemListDTO>;

}
